import { render, staticRenderFns } from "./PrestPopupVariantPierreVacance.vue?vue&type=template&id=4813401e&scoped=true"
import script from "./PrestPopupVariantPierreVacance.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrestPopupVariantPierreVacance.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PrestPopupVariantPierreVacance.vue?vue&type=style&index=0&id=4813401e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4813401e",
  null
  
)

export default component.exports